global.roleArry = [{
    name: '采购员',
    code: '1000'
}, {
    name: '客服',
    code: '5000'
}, {
    name: '管理员',
    code: '9999'
}]

global.timestampToDate = function (timestamp, showTime) {
    let newDate = new Date(timestamp);
    let timeTemp = "";
    if (showTime) {
        timeTemp = ' ' + global.addTheZero(newDate.getHours()) + ':' + global.addTheZero(newDate.getMinutes()) + ':' + global.addTheZero(newDate.getSeconds())
    }
    return newDate.getFullYear() + '-' + global.addTheZero(newDate.getMonth() + 1) + '-' + global.addTheZero(newDate.getDate()) + timeTemp;
}

global.strToDate = function(timeStr){
  let result = new Date()
  let timeArray = timeStr.split('-')
  result.setFullYear(parseInt(timeArray[0]))
  result.setMonth(parseInt(timeArray[1])-1)
  result.setDate(parseInt(timeArray[1]))
  result.setHours(0)
  result.setMinutes(0)
  result.setMilliseconds(0)
  return result
}

global.addTheZero = function (num) {
    return num < 10 ? ('0' + num) : num
}

global.splitPriceNum = function (price) {
    price = price.toFixed(2);
    price = parseFloat(price)
    price = price.toLocaleString();
    return price;
}

global.overdue = function (flag,data,that) {
    if(flag) {
		switch(data) {
			case 401:
				that.$alert('登录已过期！请您重新登录！', '错误', {
		          confirmButtonText: '确定',
				      showClose:false,
		          callback: action => {

		          }
		        });
				that.$router.push("/");

				break;
			case 403:
				that.$notify({
					title: '警告',
					message: '您暂无权限操作！',
					position: 'top-left',
					type: 'warning'
				});
				break;
		}
	}
}



// WEBPACK FOOTER //
// ./src/const/const.js